import { render, staticRenderFns } from "./PaymentAcceptancePoint.vue?vue&type=template&id=1cb00984"
import script from "./PaymentAcceptancePoint.vue?vue&type=script&lang=js"
export * from "./PaymentAcceptancePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports